import { Controller } from "@hotwired/stimulus"

// Copies the current page URL to clipboard and flashes a toast.
export default class extends Controller {
  static targets = ["toast"]
  static values = { duration: { type: Number, default: 2000 } }

  async copy(event) {
    event.preventDefault()

    try {
      await navigator.clipboard.writeText(window.location.href)
      this.showToast()
    } catch (error) {
      console.error("Clipboard write failed", error)
      this.fallbackCopy(window.location.href)
      this.showToast()
    }
  }

  showToast() {
    if (!this.hasToastTarget) return
    this.toastTarget.classList.remove("hidden")
    clearTimeout(this.hideTimeout)
    this.hideTimeout = setTimeout(() => {
      this.toastTarget.classList.add("hidden")
    }, this.durationValue)
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
  }

  disconnect() {
    clearTimeout(this.hideTimeout)
  }
}
